const translation = {
  welcome: 'wilkommen',
  partner: {
    discount_code: 'Discount Code',
    discount_code_subtext:
      'This code enables integrated checkout with discounts via Commerce Tools. If no code is set, members will use chat to purchase.',
    discount_code_none: 'None',
    select_discount_code: 'Select Discount Code',
  },
  admin_documents: {
    title: 'Downloads',
    reports: 'Buchhaltung',
    download: 'Herunterladen',
    no_reports: 'Keine Berichte verfügbar.',
    download_error:
      'Beim Herunterladen von {{name}} ist ein Fehler aufgetreten. Bitte erneut versuchen.',
  },
}

export { translation }
